import { useGetBranding } from '@sanlam-glacier/app-common/modules/theme';
import { useConfig } from 'providers/config/ConfigProvider';
import { AppBarAvatar } from '../../atoms/app-bar-avatar/AppBarAvatar';
import styles from './top-app-bar.module.scss';
import { NavMenuPages } from 'modules/app/types/navigation-menu.type';
import { routes } from 'routes/route-paths';
import { SideNavigationBar } from '../../molecules/side-navigation-bar/SideNavigationBar';
import { TopNavigationBar } from '../../molecules/top-navigation-bar/TopNavigationBar';

const navMenuItems: NavMenuPages = {
  mainPages: [
    { displayName: 'Dashboard', route: routes.dashboard, enabled: true },
    { displayName: 'My investments', route: routes.investments, enabled: true },
    { displayName: 'My details', route: routes.details, enabled: true },
    { displayName: 'Transact', route: routes.transact, enabled: true },
    { displayName: 'Tracking', route: routes.tracking, enabled: true },
    { displayName: 'Correspondence', route: routes.correspondence, enabled: true }
  ],
  subPages: [
    { displayName: 'Legal', route: routes.legal, enabled: true },
    { displayName: 'Settings', route: routes.settings, enabled: true }
  ]
};

const NavigationBarBranding = () => {
  const { theme } = useConfig();
  const { brandLogo, glacierLogo } = useGetBranding(theme);
  return (
    <div className={styles.logoContainer}>
      <img alt='Sanlam Glacier' className={styles.topBarIcon} src={glacierLogo} />
      {brandLogo && (
        <>
          <div className={styles.logoDivider} />
          <img alt='AF' className={styles.brandLogo} src={brandLogo} />
        </>
      )}
    </div>
  );
};

export const TopAppBar = () => {
  return (
    <div className={styles.appBar}>
      <SideNavigationBar items={navMenuItems} className={styles.mobileMenuContent} />
      <div className={styles.appBarInner}>
        <NavigationBarBranding />
        <TopNavigationBar items={navMenuItems} className={styles.desktopMenuContent} />
      </div>
      <AppBarAvatar />
    </div>
  );
};
